<div id="NotSignedIn" *ngIf="!isLoggedIn()">Not signed in</div>

<div id="SignedIn"    *ngIf="isLoggedIn()">Signed in
  <div id="FirstName">FirstName: {{ userDetails?.FirstName }}</div>
  <div id="LastName">LastName: {{ userDetails?.LastName }}</div>
  <div id="Email">Email: {{ userDetails?.Email }}</div>
  <div id="ProfileImageURL">ProfileImageURL: {{ userDetails?.ProfileImageURL }}</div>
  <div id="IsJobSeeker">IsJobSeeker: {{ userDetails?.IsJobSeeker }}</div>
</div>